import {useEffect, useState} from 'react'
import {Modal} from 'antd'
import {
  Box,
  Center,
  Checkbox,
  CheckboxGroup,
  Flex,
  Icon,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {ReactComponent as FeaturedIcon} from '@assets/svgs/roadmap/featured.svg'
import {ReactComponent as ArrowRight} from '@assets/svgs/roadmap/arrow_right.svg'
import {ReactComponent as CheckCircleIcon} from '@assets/svgs/check_circle.svg'
import mapRequest from '@apis/map'
import {useLocation, useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import {useDispatch, useSelector} from 'react-redux'
import appRequest from '@apis/app'
import {
  getFeedbackOverview,
  updateIsShowModalExitFlow,
} from '@redux/shared/shared'
import Loading from '@components/Loading'
import {getFeedbackExitFlowType, isLoggedIn} from '@utils'
import BackgroundDailyReview from '@assets/images/roadmap/background-daily-review.png'

const ModalExitFlow = () => {
  const {dataFeedbackOverview, isShowModalExitFlow} = useSelector(
    (state: any) => state.shared,
  )
  const [feedbackData, setFeedbackData] = useState<any>(null)
  const [selectedOptions, setSelectedOptions] = useState<string[]>([])
  const [step, setStep] = useState<number>(1)
  const [content1, setContent1] = useState<string>('')
  const [content2, setContent2] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch: any = useDispatch()

  useEffect(() => {
    if (isShowModalExitFlow) {
      getFeedbackData()
    }
  }, [isShowModalExitFlow])

  const getFeedbackData = async () => {
    setIsLoading(true)
    try {
      const params = {
        'feedback-id':
          dataFeedbackOverview?.feedback_data[
            getFeedbackExitFlowType(location.pathname)
          ]?.feedback_id,
      }
      const res = await mapRequest.getFeedbackData(params)
      if (res) {
        setFeedbackData(res?.data?.data)
      }
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    dispatch(updateIsShowModalExitFlow(false))
    setSelectedOptions([])
    setContent1('')
    setContent2('')
    setStep(1)
  }

  const handleCheckboxChange = (value: string) => {
    if (selectedOptions.includes(value)) {
      setSelectedOptions(selectedOptions.filter(option => option !== value))
    } else if (selectedOptions.length < 2) {
      setSelectedOptions([...selectedOptions, value])
    }
  }
  const handleChangeContent1 = (e: any) => {
    setContent1(e.target.value)
  }
  const handleOnchangeContent2 = (e: any) => {
    setContent2(e.target.value)
  }

  const handleSubmit = async () => {
    switch (step) {
      case 1:
        setStep(2)
        break
      case 2:
        try {
          let params
          if (isLoggedIn()) {
            params = {
              feedback_data_id:
                dataFeedbackOverview?.feedback_data[
                  getFeedbackExitFlowType(location.pathname)
                ]?.feedback_id,
              reason: `${selectedOptions.join(',')} ${content1}`,
              improvement: content2,
            }
          } else {
            params = {
              feedback_data_id:
                dataFeedbackOverview?.feedback_data[
                  getFeedbackExitFlowType(location.pathname)
                ]?.feedback_id,
              feedback_data: {
                reason: `${selectedOptions.join(',')} ${content1}`,
                improvement: content2,
              },
            }
          }
          const res = await appRequest.submitExitFlowFeedback(params)
          dispatch(getFeedbackOverview())
        } catch (error) {}
        setStep(3)
        break
      case 3:
        navigate(PATH.HOME, {replace: true})
        handleCancel()
        break
      default:
        break
    }
  }

  return (
    <Modal
      open={isShowModalExitFlow}
      width={'400px'}
      title={
        <Center
          position={'relative'}
          w={'48px'}
          h={'48px'}
          border={'1px solid #EAECF0'}
          borderRadius={'50%'}>
          <Icon w={'24px'} h={'24px'}>
            {step === 3 ? <CheckCircleIcon /> : <FeaturedIcon />}
          </Icon>
          <Box
            position={'absolute'}
            top={'50% '}
            left={'50%'}
            transform={'translate(-50%, -50%)'}
            w={'300px'}
            h={'300px'}
            bgImage={BackgroundDailyReview}
            bgSize={'cover'}
            bgPosition={'center'}
          />
        </Center>
      }
      centered={true}
      footer={null}
      onCancel={handleCancel}
      style={{
        overflow: 'hidden',
      }}>
      <Text fontSize={'18px'} fontWeight={600}>
        {step === 3
          ? 'Cảm ơn bạn nhiều'
          : feedbackData?.feedback_data[step - 1].text}
      </Text>
      <Text color={'#475467'} mb={'20px'}>
        {step === 1 && 'Chọn nhiều nhất 2 đáp án'}
        {step === 2 && 'Hãy chia sẻ để chúng mình hỗ trợ bạn tốt hơn'}
        {step === 3 && 'Hẹn gặp bạn trong bài học tiếp theo nha!'}
      </Text>
      {step === 1 && (
        <>
          <CheckboxGroup colorScheme="blue" value={selectedOptions}>
            <Stack flexDirection={'column'}>
              {feedbackData?.feedback_data[step - 1].options.map(
                (option: any, index: any) => (
                  <Checkbox
                    key={index}
                    value={option}
                    isChecked={selectedOptions.includes(option)}
                    onChange={() => handleCheckboxChange(option)}>
                    {option === 'USER_INPUT' ? 'Khác' : option}
                  </Checkbox>
                ),
              )}
            </Stack>
          </CheckboxGroup>
          {selectedOptions.includes('USER_INPUT') && (
            <Textarea
              mt={'12px'}
              w={'100%'}
              placeholder="Nhập tối thiểu 30 ký tự"
              onChange={handleChangeContent1}
            />
          )}
        </>
      )}
      {step === 2 && (
        <Textarea
          placeholder="Nhập nội dung"
          resize={'none'}
          onChange={handleOnchangeContent2}
        />
      )}
      <Flex mt={'24px'} gap={'12px'}>
        {step === 2 && (
          <GlobalButton
            flex={1}
            color={'black'}
            bg={'transparent'}
            border={'1px solid #D0D5DD'}
            _hover={{
              bg: 'transparent',
            }}
            onClick={() => setStep(1)}>
            Chọn lại
          </GlobalButton>
        )}
        <GlobalButton
          flex={1}
          onClick={handleSubmit}
          isDisabled={step === 1 && selectedOptions.length === 0}>
          {step === 3 ? (
            <>
              <Icon
                as={ArrowRight}
                mr={2}
                w={'20px'}
                h={'20px'}
                transform="rotate(180deg)"
                sx={{
                  path: {
                    stroke: 'white',
                  },
                }}
              />
              Quay lại lộ trình
            </>
          ) : (
            'Gửi'
          )}
        </GlobalButton>
      </Flex>
      {isLoading && <Loading />}
    </Modal>
  )
}

export default ModalExitFlow
